// echo.js
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const echo = new Echo({
  broadcaster: 'pusher',
  //key: 'cca652d35e7c91eccd6e', // your real Pusher key
  key: '1234555555', // your real Pusher key
  cluster: 'ap2',              // your Pusher cluster
  forceTLS: true,              // use SSL
  encrypted: true,
});

export default echo;
